import React, { useContext } from 'react'
import AccountTree from '../../components/tab/tabview/AccountTree'
import { Divider, Typography } from '@mui/material'
import { ThemeContext } from '../../context/ThemeContext'
import { useTranslation } from 'react-i18next'

export default function Account() {
  const { darkMode } = useContext(ThemeContext)
  const { t } = useTranslation()

  return (
    <>
      <Typography sx={{ textAlign: 'center', m: 1, color: darkMode ? "var(--lightText)" : 'var(--darkText)' }}>{t('accounts')}</Typography>
      <Divider />
      <AccountTree />
    </>
  )
}
